import DataStore from "@/components/GridWidget/DataStore";
import {getParameter} from "@/components/WdiBus/Buttons/data";
import {WdiModalAppProps, wdiCore} from "@/components/WdiControls";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {FormSa, FormSaDetail} from "@/services/sales/sa";
import {formatter, request, ResponseStatus} from "@/utils/request";
import {ProFormInstance} from "@ant-design/pro-form";
import {DatePicker, message, TableColumnsType,} from "antd";
import {useEffect, useRef, useState} from "react";
import {Enum} from "@/enums/system";
import moment from "moment/moment";
import {WdiSelect} from "@/components/WdiControls/WdiSelect";

const ModifyPdPriceModalApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [dataSource, setDataSource] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const columns: TableColumnsType<API.FormSaDetailVo> = [
    {
      title: '行号',
      width: 50,
      dataIndex: 'rowNumber',
    },
    {
      title: '费用项',
      dataIndex: 'ecName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '核算类型',
      dataIndex: 'revenueTypeName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '购买产品',
      dataIndex: 'productBuyNames',
      ellipsis: true,
      width: 240,
    },
    {
      title: '原供货价(箱/大袋)',
      dataIndex: 'priceSellinBefore',
      width: 130,
      ellipsis: true,
      render: (value) => wdiCore.Number.AmountToString(value, 4),
    },
    {
      title: '原促销供货价(箱/大袋)',
      dataIndex: 'priceSellinAfterOriginal',
      width: 160,
      ellipsis: true,
      render: (value) => wdiCore.Number.AmountToString(value, 4),
    },
    {
      title: '低于限价比例',
      dataIndex: 'priceLimitBelowRate',
      width: 100,
      ellipsis: true,
      render: (value) => wdiCore.Number.RateToString(value),
    },
    {
      title: '原促销零售价(中包)',
      dataIndex: 'pricePosAfterOriginal',
      width: 165,
      ellipsis: true,
      render: (value) => wdiCore.Number.AmountToString(value),
    },
    {
      title: '新促销供货价(箱/大袋)',
      dataIndex: 'priceSellinAfter',
      width: 160,
      ellipsis: true,
      render: (value: any, record) => {
        return (
          <WdiInputNumber
            value={value} min={0} style={{width: '100%'}} digits={4}
            onChange={(value) => {
              const {...newRecord} = record;
              newRecord.priceSellinAfter = Number(value);
              setDataSource(DataStore.edit(dataSource, newRecord));
            }}
          />
        );
      },
    },
    {
      title: '新促销零售价(中包)',
      dataIndex: 'pricePosAfter',
      width: 165,
      ellipsis: true,
      render: (value: any, record) => {
        return (record.revenueType == Enum.RevenueType.DISCOUNT_KA ? (
            <WdiInputNumber
              value={value} min={0} style={{width: '100%'}} digits={2}
              onChange={(value) => {
                const {...newRecord} = record;
                newRecord.pricePosAfter = Number(value);
                setDataSource(DataStore.edit(dataSource, newRecord));
              }}/>
          ) : (wdiCore.Number.AmountToString(value))
        );
      },
    },
    {
      title: '供货期间',
      dataIndex: 'supplyStartDate',
      ellipsis: true,
      width: 300,
      render: (_, record) => {
        return (
          <DatePicker.RangePicker
            style={{width: '100%'}}
            value={[moment(record.supplyStartDate), moment(record.supplyEndDate)]}
            format={'YYYY-MM-DD'}
            disabledDate={(current) => {
              return current > moment(record.supplyEndDateSa) || current < moment(record.supplyStartDateSa);
            }}
            onChange={(value) => {
              const {...newRecord} = record;
              if (value && value.length == 2) {
                newRecord.supplyStartDate = moment(value[0]).format('YYYY-MM-DD');
                newRecord.supplyEndDate = moment(value[1]).format('YYYY-MM-DD');
              }
              setDataSource(DataStore.edit(dataSource, newRecord));
            }}
          />
        )
      },
    },
    {
      title: '是否限量',
      dataIndex: 'isLimited',
      width: 110,
      ellipsis: true,
      render: (value, record) => {
        return (
          <WdiSelect
            {...{
              style: {width: '100%'},
              value: Number(value),
              placeholder: '请选择是否限量',
              options: [
                {label: '是', value: 1},
                {label: '否', value: 0},
              ],
              onChange: (value) => {
                const {...newRecord} = record;
                newRecord.isLimited = Boolean(value);
                setDataSource(DataStore.edit(dataSource, newRecord));
              }
            }}
          />
        )
      },
    },
  ]

  useEffect(() => {
    if (props.id) {
      setLoading(true);
      Promise.all([
        FormSaDetail.getsEx(Number(props.id)),
        FormSa.get(Number(props.id))
      ]).then((dataArray) => {
        const resp1 = dataArray[0];
        const resp2 = dataArray[1];
        const formSa = resp2.data;
        const formSaDetails = resp1.data.filter(m => m.revenueType != Enum.RevenueType.BUY_GIVE);
        for (let i = 0; i < formSaDetails.length; i++) {
          const formSaDetail = formSaDetails[i];
          formSaDetail.supplyStartDateSa = moment(formSa.supplyStartDate).format('YYYY-MM-DD');
          formSaDetail.supplyEndDateSa = moment(formSa.supplyEndDate).format('YYYY-MM-DD');
          if (wdiCore.Object.IsNullOrUndefined(formSaDetail.supplyStartDate)) {
            formSaDetail.supplyStartDate = formSaDetail.supplyStartDateSa;
          }
          if (wdiCore.Object.IsNullOrUndefined(formSaDetail.supplyEndDate)) {
            formSaDetail.supplyEndDate = formSaDetail.supplyEndDateSa;
          }
          formSaDetail.pricePosAfterOriginal = formSaDetail.pricePosAfter;
        }
        setDataSource(DataStore.init(formSaDetails));
        setLoading(false);
      });
    }
  }, [props.id]);

  return (
    <WdiModalForm
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      width={1350}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      onFinish={async () => {
        const {data} = props;
        const args = getParameter(data);
        args.items.push({name: "formSaDetails", value: JSON.stringify(dataSource)});
        const response = await request(data.url, formatter({method: 'POST', body: args}));
        if (response.code == ResponseStatus.SUCCESS) {
          message.success('操作成功');
          if (props.onSave) {
            props.onSave();
          }
        } else {
          message.error(response.message);
        }
      }}
    >
      <WdiTable
        height={507}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        footerSummaryFixed={true}
        allowFilterColumn={true}
      />
    </WdiModalForm>
  );
};

export default ModifyPdPriceModalApp;
